import { useMemo } from 'react';
import { ENDPOINTS } from 'features/daily-plan/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';
import { UIStatus } from 'UI/constants/status';

import { TASK_DETAILS_INCLUDES } from './TaskDetailsDrawer.constants';

export const useTaskDetails = taskId => {
  const { state, refreshData } = useFetchWithStatusV2({
    endpoint: `${ENDPOINTS.task.replace(':id', taskId)}?includes=${TASK_DETAILS_INCLUDES.join(
      ','
    )}`,
    initialStatus: UIStatus.Default
  });

  const formattedDate = useMemo(() => {
    const startDate = state?.results?.startDatetime;
    const isOnlyDate = state?.results?.startDatetimeIsOnlyDate;
    return isOnlyDate
      ? moment.parseZone(startDate).format(DateFormats.MonthDayYear)
      : moment(startDate).format(DateFormats.MonthDayYearTime);
  }, [state]);

  const parsedEntity = useMemo(() => {
    const entity = state?.results?.entity;
    return {
      company: { id: entity?.companyId, name: entity?.company },
      email: entity?.email,
      id: entity?.id,
      location: entity?.location,
      name: entity?.contactName,
      phone: entity?.phone,
      phones: entity?.phones,
      title: entity?.title,
      type: entity?.type
    };
  }, [state]);

  return {
    formattedDate,
    parsedEntity,
    status: state.status,
    error: state.error,
    task: state?.results,
    refreshData
  };
};
